import { SVGProps } from 'react';

/** Outline upload icon for header bars. Uses `currentColor`. */
export const UploadOutlineIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg data-icon width="16" height="16" viewBox="0 0 165 165" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M158 119V138C158 149.046 149.046 158 138 158H27C15.9543 158 7 149.046 7 138V119"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinecap="round"
    />
    <path
      d="M83 122.235C79.134 122.235 76 119.101 76 115.235V49.7349H61.7422C55.4838 49.7349 51.6489 42.8726 54.9287 37.5425L75.6865 3.80713C78.8104 -1.26909 86.1896 -1.2691 89.3135 3.80713L110.071 37.5425C113.351 42.8726 109.516 49.7349 103.258 49.7349H90V115.235C90 119.101 86.866 122.235 83 122.235Z"
      fill="currentColor"
    />
  </svg>
);
